<template>
  <el-dialog
    title="编辑商户报单"
    :visible.sync="dialogVisible"
    width="80%"
    :close-on-click-modal="false"
    append-to-body
    @open="handleOpen"
  >
    <el-form :model="info" :rules="rules" ref="infoForm" label-width="120px">
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>店铺信息:</span>
        </div>
        <el-row>
          <el-col :span="8"><strong>店铺名称:</strong> {{ info.shopName }}</el-col>
          <el-col :span="8"><strong>店铺电话:</strong> {{ info.shopMobile }}</el-col>
          <el-col :span="8"><strong>店铺地址:</strong> {{ info.shopAddress }}</el-col>
        </el-row>
      </el-card>
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>商户报单信息:</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户姓名" prop="customName">
              <el-input v-model="info.customName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户手机号" prop="customMobile">
              <el-input v-model="info.customMobile"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户地址" prop="customAddress">
              <el-input v-model="info.customAddress"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="安装时间" prop="installTime">
              <el-date-picker v-model="info.installTime" type="datetime" @change="handleInstallTimeChange"
                placeholder="选择安装时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col v-if="info.preEmbedded == 'YES' || info.preEmbedded == '是'" :span="12">
            <el-form-item label="预埋" prop="preEmbedded">
              <el-select v-model="info.preEmbedded" placeholder="选择预埋情况" @change="handlePreEmbeddedChange">
                <el-option label="是" value="YES"></el-option>
                <el-option label="否" value="NO"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-else :span="24">
            <el-form-item label="预埋" prop="preEmbedded">
              <el-select v-model="info.preEmbedded" placeholder="选择预埋情况" @change="handlePreEmbeddedChange">
                <el-option label="是" value="YES"></el-option>
                <el-option label="否" value="NO"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="info.preEmbedded == 'YES' || info.preEmbedded == '是'" :span="12">
            <el-form-item label="管线预埋长度" prop="lineLength">
              <el-input v-model="info.lineLength"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="返利人">
              <el-input v-model="info.reference"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="返利金额">
              <el-input v-model="info.rebateAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="零售价">
              <el-input v-model="info.retailPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="额外费用支付人" prop="additionalLaborPayer">
              <el-select v-model="info.additionalLaborPayer" placeholder="选择安装额外费用支付人">
                <el-option label="经销商" value="经销商"></el-option>
                <el-option label="业主" value="业主"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="picUrl" label="付款凭证">
              <ImageUpload action="#" :multiple="true" :inTable="true" :limit="5" @uploaded="handleUploaded"
                :uploaded-images="info.picUrl" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="info.remarks"></el-input>
        </el-form-item>

        <!-- 商品选择表格 -->
        <el-form-item label="商品列表" prop="selectedGoods">
          <el-table :data="selectedGoods" style="width: 100%" border>
            <el-table-column prop="goodsId" label="商品名称">
              <template slot-scope="scope">
                <el-select v-model="scope.row.goodsId" placeholder="请选择商品" :disabled="!isEditable(scope.row)"
                  filterable @change="handleGoodsChange(scope.row)">
                  <el-option v-for="goods in goodsList" :key="goods.id" :label="goods.name" :value="goods.id"
                    :disabled="isOptionDisabled(goods.id)"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="数量">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.num" :min="1" :step="1"
                  :disabled="!isEditable(scope.row)"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="danger" icon="el-icon-minus" @click="removeGoods(scope.$index)"
                  :disabled="!isEditable(scope.row)">删除商品</el-button>
                <el-button type="primary" icon="el-icon-plus" @click="addGoods"
                  style="margin-top: 10px;">添加商品</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" icon="el-icon-plus" @click="addGoods"
            v-if="selectedGoods.length === 0">添加商品</el-button>
        </el-form-item>
      </el-card>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="small" @click="handleClose" icon="el-icon-circle-close-outline">取消</el-button>
      <el-button type="primary" size="small" @click="submit" icon="el-icon-circle-check-outline">确定修改</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getMerchantOrder, editMerchantOrder, getGoodList } from "@/api/work/waterProject/merchants";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import ImageUpload from "@/components/imageUpload/ImageUpload";
export default {
  components: {
    ImageUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      goodsList: [],
      selectedGoods: [],
      info: {
        customName: "",
        customMobile: "",
        customAddress: "",
        installTime: null,
        preEmbedded: "",
        lineLength: "",
        retailPrice: "",
        remarks: ""
      },
      baseRules: {},
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    rules() {
      const rules = { ...this.baseRules };
      if (this.info.preEmbedded === 'YES') {
        rules.lineLength = [{ required: true, message: "请输入管线预埋长度", trigger: "blur" }];
      }
      return rules;
    }
  },
  methods: {
    handleOpen() {
      this.loadData();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    loadData() {
      const id = this.id;
      this.info = {
        customName: "",
        customMobile: "",
        customAddress: "",
        installTime: null,
        preEmbedded: "",
        lineLength: "",
        retailPrice: "",
        remarks: ""
      };
      this.selectedGoods = [];
      if (!id) return;
      getMerchantOrder(id).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = data;
          this.info.picUrl = data.picUrl || [];
          if (data.list && data.list.length > 0) {
            this.processSelectedGoods(data.list);
          } else {
            getGoodList(id).then(res => {
              if (res.code === '200') {
                const goodsData = JSON.parse(res.data);
                this.selectedGoods = goodsData;
                this.processSelectedGoods(goodsData);
              } else {
                this.$message.error('获取商品列表失败');
                this.processSelectedGoods([]);
              }
            }).catch(() => {
              this.$message.error('获取商品列表接口调用失败');
              this.processSelectedGoods([]);
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    handleUploaded(urls) {
      this.info.picUrl = urls;
    },
    handlePreEmbeddedChange(value) {
      if (value == 'NO') {
        this.info.lineLength = "";
      }
    },
    handleInstallTimeChange(value) {
      if (value) {
        const timestamp = new Date(value).getTime();
        this.info.installTime = timestamp;
      } else {
        this.info.installTime = null;
      }
    },
    processSelectedGoods(selectedGoods) {
      const type = 'PURE_WATER'
      findPureWaterGoodsByRootDepartId(type).then(res => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = data;
            if (Array.isArray(selectedGoods)) {
              this.selectedGoods = selectedGoods.map(item => ({
                goodsId: item.goodsId,
                num: item.num,
                serviceOrderId: item.serviceOrderId || '',
                declarationId: item.declarationId || '',
                name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : ""
              }));
            } else {
              this.selectedGoods = [];
            }
          } else {
            this.goodsList = [];
            this.selectedGoods = [];
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    handleGoodsChange(row) {
      const selectedGoods = this.goodsList.find(goods => goods.id === row.goodsId);
      if (selectedGoods) {
        row.goodsId = selectedGoods.id;
        row.name = selectedGoods.name;
      } else {
        row.goodsId = null;
        row.name = '';
      }
    },
    addGoods() {
      if (this.selectedGoods.length === this.goodsList.length) {
        this.$message({
          showClose: true,
          message: "所有商品都已经选择",
          type: "warning"
        });
        return;
      } else {
        this.selectedGoods.push({ goodsId: null, num: 1 });
      }
    },
    removeGoods(index) {
      this.selectedGoods.splice(index, 1);
    },
    isEditable(item) {
      return !item.serviceOrderId;
    },
    isOptionDisabled(goodsId) {
      return this.selectedGoods.some(item => item.goodsId === goodsId);
    },
    submit() {
      this.info.preEmbedded = this.info.preEmbedded == ("YES" || "是") ? "是" : "否";
      this.info.productName = this.selectedGoods.map((g) => `${g.name}*${g.num}`).join(",");
      this.info.productId = this.selectedGoods.map((g) => g.goodsId).join(",");
      if (Array.isArray(this.info.picUrl)) {
        this.info.picUrl = this.info.picUrl.map(item => item.url).join(",");
      }
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          const submitData = {
            ...this.info,
            list: this.selectedGoods
          };
          if (Array.isArray(submitData.picUrl)) {
            submitData.picUrl = submitData.picUrl.join(',');
          }
          editMerchantOrder(submitData).then(res => {
            if (res.code === "200") {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success"
              });
              this.$emit("refresh");
              this.dialogVisible = false;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完整填写必填信息",
            type: "error"
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.card {
  margin-bottom: 20px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
